import * as actionTypes from '../actions/actionTypes';

const getMutations = {
  [actionTypes.GET_DUPLICATE_START](state) {
    state.isDuplicateLoading = true;
  },
  [actionTypes.GET_DUPLICATE_SUCCESS](state, payload) {
    state.isDuplicateLoading = false;
    state.duplicate = payload;
  },
  [actionTypes.GET_DUPLICATE_FAIL](state, payload) {
    state.isDuplicateLoading = false;
    state.duplicateError = payload;
  },
};

const getDuplicateInfoMutations = {
  [actionTypes.GET_DUPLICATE_INFO_START](state) {
    state.isDuplicateLoading = true;
  },
  [actionTypes.GET_DUPLICATE_INFO_SUCCESS](state, payload) {
    state.isDuplicateLoading = false;
    state.duplicatesToResolve = payload;
  },
  [actionTypes.GET_DUPLICATE_INFO_FAIL](state, payload) {
    state.isDuplicateLoading = false;
    state.duplicateError = payload;
  },
};

const listMutations = {
  [actionTypes.LIST_DUPLICATES_START](state) {
    state.isDuplicateLoading = true;
  },
  [actionTypes.LIST_DUPLICATES_SUCCESS](state, payload) {
    state.isDuplicateLoading = false;
    state.duplicates = payload;
  },
  [actionTypes.LIST_DUPLICATES_FAIL](state, payload) {
    state.isDuplicateLoading = false;
    state.duplicateError = payload;
  },
};

const updateMutations = {
  [actionTypes.UPDATE_DUPLICATE_START](state) {
    state.isDuplicateLoading = true;
  },
  [actionTypes.UPDATE_DUPLICATE_SUCCESS](state) {
    state.isDuplicateLoading = false;
  },
  [actionTypes.UPDATE_DUPLICATE_FAIL](state, payload) {
    state.isDuplicateLoading = false;
    state.duplicateError = payload;
  },
};

const setDuplicateToResolveMutation = {
  [actionTypes.SET_DUPLICATE_TO_RESOLVE](state, payload) {
    state.duplicateIdsToResolve = payload;
    state.duplicatesToResolve = [];
  },
};

const clearDuplicatesUpdateMutation = {
  [actionTypes.CLEAR_DUPLICATE_UPDATE_STATE](state) {
    state.duplicateIdsToResolve = [];
    state.duplicatesToResolve = [];
    state.duplicateError = null;
  }
};


const mutations = {
  ...getMutations,
  ...getDuplicateInfoMutations,
  ...listMutations,
  ...updateMutations,
  ...setDuplicateToResolveMutation,
  ...clearDuplicatesUpdateMutation,
};

export default mutations;
